export default __webpack_public_path__ + "static/media/diamond_video4.6e1f750d.png";